import React from 'react';
import { ConnectedTopDestinationsMobile } from './TopDestinationsMobile';
import { Config, LocationUtils } from '../../utils';

export function TopDestinationsSourceMobile({ id, activeProduct }) {
    return {
        render: ({ onClickItem, displayedWord = '' } = {}) => {
            const show = !LocationUtils.isKeywordLongEnoughAccordingWithLanguage(
                displayedWord,
                Config.get('autocompleteOptions'),
                activeProduct,
            );
            return (
                <ConnectedTopDestinationsMobile
                    key="top-destinations"
                    id={id}
                    onClickItem={onClickItem}
                    show={show}
                />
            );
        },
    };
}
